import api from 'utils/api';

const removeEmptyParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== '',
    ),
  );

export const getSinohehReferrals = async ({
  status,
  priority,
  client,
  includeArchived,
} = {}) => {
  const response = await api.get('/api/sinoheh/referrals', {
    params: removeEmptyParams({ status, priority, client, includeArchived }),
  });
  return response.data;
};

export const getSinohehReferral = async (id) => {
  const response = await api.get(`/api/sinoheh/referrals/${id}`);
  return response.data;
};

export const updateSinohehReferral = async (id, payload) => {
  const response = await api.patch(`/api/sinoheh/referrals/${id}`, payload);
  return response.data;
};

export const archiveSinohehReferral = async (id) => {
  const response = await api.patch(`/api/sinoheh/referrals/${id}/archive`);
  return response.data;
};
